// Sentry side-effect instrumentation.
//
// Must be imported **first** in the app entry (main.tsx), before any module
// that creates the query client or renders a component, so Sentry.init has run
// by the time those modules evaluate. Browser tracing only measures from the
// moment init runs, so a late init loses the pageload transaction entirely.
//

// This file only runs the init side effect; it exports nothing.
import { sentryInit } from './utils/error-tracking/error-tracking';

sentryInit();
